import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate } from "react-router-dom";
import { isVendorAdminUser } from "./AuthState";

function AdminRoutes() {
  const { userInformation } = useContext(UserContext);
  const isAdmin = isVendorAdminUser(userInformation);

  return isAdmin ? <Outlet /> : <Navigate to="/library" replace />;
}

export default AdminRoutes;
